module.exports = __webpack_public_path__ + "static/media/IMG_20201031_121833_003.ee4d1fd0.jpg";